import React from "react";
import DefaultView from "../../layouts/content/DefaultView/DefaultView";
import { getTranslation as translate } from "logic/LocaleManager";
import parse from 'html-react-parser';

function AboutPage(props) {
  const text = "Canotis BOS <b>WebWorkspace</b><br/>shipped by <b>Canotis AG &copy;</b><br/>Visit us here: <a href='https://www.canotis.de' target='_blank'>Canotis AG</a>"
  return (
    <DefaultView>
      <div className={"ui-default-headline"}>{translate("aboutPage.title", "Info")}</div>
      <div>
        {parse(translate("aboutPage.text", text))}
      </div>
    </DefaultView>
  );
}

export default AboutPage;
